// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionsProductListLineStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

requisitionsProductListLineStyles.imageGridItem = {
    ...requisitionsProductListLineStyles.imageGridItem,
    css: css`
        ${requisitionsProductListLineStyles.imageGridItem?.css}
        ${screen("lte", "sm")`
            flex-basis: 100%;
            max-width: 100%;
            justify-content: space-between;
            flex-direction: row-reverse;
        `};
    `,
};

requisitionsProductListLineStyles.selectedCheckbox = {
    ...requisitionsProductListLineStyles.selectedCheckbox,
    css: css`
        ${requisitionsProductListLineStyles.selectedCheckbox?.css}
        ${screen("lte", "sm")`
            margin-right: 0;
        `};
    `,
};

requisitionsProductListLineStyles.imageWrapper = {
    ...requisitionsProductListLineStyles.imageWrapper,
    css: css`
        ${requisitionsProductListLineStyles.imageWrapper?.css}
        ${screen("lte", "sm")`
            width: 116px;
            height: 92px;
            min-width: 116px;
            min-height: 92px;
            overflow: hidden;
            margin-bottom: 10px;
        `};
    `,
};

requisitionsProductListLineStyles.mainContainer = {
    ...requisitionsProductListLineStyles.mainContainer,
    css: css`
        ${requisitionsProductListLineStyles.mainContainer?.css}
        div[class^="GridOffset"] {
            width: auto;
        }
    `,
};

requisitionsProductListLineStyles.infoGridItem = {
    ...requisitionsProductListLineStyles.infoGridItem,
    width: [12, 12, 10, 10, 10],
};
